module.exports = __webpack_public_path__ + "static/assets/26be465e5735ab294b73c1852a923297.svg";